module.exports = __webpack_public_path__ + "img/1360984677.b354e3b3.jpg";